import { ReactNode, useEffect } from "react";
import { LanguageSelect } from "../LanguageSelect/LanguageSelect";
import { AuthLogo } from "./AuthLogo";
import authHero from "../../assets/auth/auth-hero.jpg";
import "./AuthSplitLayout.css";

type AuthSplitLayoutProps = {
  children: ReactNode;
  fullWidth?: boolean;
};

export const AuthSplitLayout = ({ children }: AuthSplitLayoutProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="auth-split">
      <div className="auth-split__photo" aria-hidden>
        <img src={authHero} alt="" className="auth-split__photo-img" />
      </div>
      <div className="auth-split__panel">
        <div className="auth-split__lang">
          <LanguageSelect color="#000" />
        </div>
        <div className="auth-split__content">
          <div className="auth-split__logo">
            <AuthLogo />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

type AuthHeadlineProps = {
  children: ReactNode;
};

export const AuthHeadline = ({ children }: AuthHeadlineProps) => (
  <h1 className="auth-split__headline">{children}</h1>
);

type AuthSubtextProps = {
  children: ReactNode;
};

export const AuthSubtext = ({ children }: AuthSubtextProps) => (
  <p className="auth-split__subtext">{children}</p>
);

export const AuthFormSection = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div className={className ? `auth-split__form ${className}` : "auth-split__form"}>
    {children}
  </div>
);

export const AuthFooterLink = ({ children }: { children: ReactNode }) => (
  <div className="auth-split__footer-link">{children}</div>
);
